import { useState } from "react";
import { Flex } from "rebass/styled-components";
import { useMutation } from "@apollo/client";

import { SettingsContainer } from "../../../components/molecules/settingsContainer";
import { DividerAlt } from "../../../components/atoms/dividerAlt";
import { Body } from "../../../components/text";
import Toggle from "components/atoms/toggle";
import { DISABLED_COMMENTS } from "MVVM/GraphQL/clipComments";
import { useUser } from "MVVM/Hooks/useUser";
import { analytics } from "MVVM/Analytics";

const DisableComments = () => {
  const { allstarUser, getFreshProfile } = useUser();
  const [disabled, setDisabled] = useState(allstarUser.user?.commentsDisabled);
  const [toggleDisabledComments] = useMutation(DISABLED_COMMENTS);

  const handleChange = () => {
    setDisabled(!disabled);
    toggleDisabledComments();
    getFreshProfile();
    analytics.track(`User ${disabled ? "disabled" : "enabled"} comments.`, {});
  };

  return (
    <SettingsContainer title="Comments" subtitle="" mt={6}>
      <DividerAlt></DividerAlt>
      <Body color="ice" mb={3}>
        <Flex
          mb={6}
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Body color="ice">Disable commenting on all my clips</Body>
          <Toggle checked={!!disabled} onChange={handleChange} />
        </Flex>
      </Body>
    </SettingsContainer>
  );
};

export { DisableComments };
